import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Boutton from "../../components/Button";
import BtnPlayStore from "../../components/BtnPlayStore";
import BtnAppStore from "../../components/BtnAppStore";

const Teleconsultation = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut", staggerChildren: 0.2 },
    },
  };
  const staggerContainer = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const zoomRotate = {
    hidden: { scale: 0.8, rotate: -15, opacity: 0 },
    visible: { scale: 1, rotate: 0, opacity: 1, transition: { duration: 1 } },
  };

  // composant (cartes) reutilisable

  const items = [
    {
      icon: "/assets/images/vecteurs/smartphone-svgrepo-com.svg",
      title: t("teleconsultation.Cards.Accessibilite"),
      description: t("teleconsultation.Cards.AccessibiliteTexte"),
      bgColor: "bg-[#DBEAFF]",
    },
    {
      icon: "/assets/images/vecteurs/time-success-svgrepo-com.svg ",
      title: t("teleconsultation.Cards.Gain"),
      description: t("teleconsultation.Cards.GainTexte"),
      bgColor: "bg-[#DBEAFF]",
    },

    {
      icon: "/assets/images/vecteurs/list-square-svgrepo-com.svg",
      title: t("teleconsultation.Cards.Suivi"),
      description: t("teleconsultation.Cards.SuiviTexte"),
      bgColor: "bg-[#DBEAFF]",
    },
    {
      icon: "/assets/images/vecteurs/pig-shaped-piggy-bank-dollar-version-svgrepo-com.svg",
      title: t("teleconsultation.Cards.Reduction"),
      description: t("teleconsultation.Cards.ReductionTexte"),
      bgColor: "bg-[#DBEAFF]",
    },
  ];

  return (
    <main className="max-w-[1900px] mx-auto">
      {/**  SECTION ONE */}
      <motion.section
        id="landing"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
        className="max-w-[1550px] mx-auto"
      >
        <motion.div
          id="container"
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="pt-24 px-5 lg:px-16"
        >
          <div
            className=" w-full  pl-6 lg:pl-12 pt-8 pb-0 rounded-3xl gradient text-white text-center lg:text-left
           md:flex gap-8  "
          >
            <div className="max-sm:pb-6 max-md:pr-6 mb-2 md:mb-6 flex flex-col  md:justify-center md:w-[60%] ">
              <h1 className="  font-extrabold mb-4 text-3xl">
                {t("teleconsultation.hero.titreHero")}
              </h1>
              <p className=" mb-4">{t("teleconsultation.hero.paraph")}</p>
              <p className="flex sm:hidden md:flex font-bold mb-4 justify-center lg:justify-start">
                {t("teleconsultation.hero.telecharger")}
              </p>
              <div className=" flex sm:hidden md:flex *:h-12 gap-4 lg:justify-start justify-center">
                <BtnAppStore />
                <BtnPlayStore />
              </div>
            </div>
            <div className="hidden sm:flex md:justify-center justify-end ">
              <div className="hidden sm:flex md:hidden flex-col items-center mt-[10%] ">
                <p className="flex font-bold mb-8">
                  {t("teleconsultation.hero.telecharger")}
                </p>
                <div className=" flex flex-col items-center gap-4 mr-[5%] ">
                  <BtnAppStore />
                  <BtnPlayStore />
                </div>
              </div>
              <img
                src="/assets/images/teleconsultation/hero.png"
                alt=""
                className="w-[350px] lg:w-[500px] 2xl:w-[550px] rounded-3xl"
              />
            </div>
          </div>
        </motion.div>
      </motion.section>

      {/**  SECTION TWO */}
      <motion.section
        id="landing"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
        className="max-w-[1550px] mx-auto"
      >
        <motion.div
          id="container"
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="mt-12 py-8 lg:px-16 shadow-gray-400 max-sm:bg-slate-200 shadow-2xl"
        >
          <div className="flex ">
            <div className=" hidden  md:flex  max-lg:justify-center max-lg:items-center lg:pt-36 xl:pt-[10%] max-[880px]:w-[65%] w-1/2 ">
              <div
                className=" lg:mx-[4%] min-[1350px]:mx-[12%] relative  bg-cover rounded-[28px] max-lg:h-[320px] max-lg:w-[320px] h-[370px] w-[370px] xl:h-[470px] xl:w-[470px] "
                style={{
                  backgroundImage:
                    "url(/assets/images/teleconsultation/telebg.png)",
                }}
              >
                <div
                  className="absolute bottom-0 left-0 bg-cover  max-lg:h-[350px]  max-lg:w-[350px] h-[430px] w-[430px]  xl:h-[530px] xl:w-[530px]"
                  style={{
                    backgroundImage:
                      "url(/assets/images/teleconsultation/comment_ca_marche.png)",
                  }}
                >
                  <div
                    className="absolute max-lg:top-[-12%] max-lg:left-[51%] top-[-5%] left-[52%] xl:top-[-7%] xl:left-[52%] bg-cover max-lg:h-[90px] max-lg:w-[90px] h-[100px] w-[100px] xl:h-[120px] xl:w-[120px] rotate-45"
                    style={{
                      backgroundImage:
                        "url(/assets/images/vecteurs/question-mark-svgrepo-com.svg)",
                    }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="p-4 max-md:w-full xl:w-1/2">
              <p className=" text-[22px] sm:text-[30px] md:text-[18px] font-bold text-blue-primary sm:pb-4 text-center">
                {t("teleconsultation.section2.comment")}
              </p>
              <div className="">
                <div className="py-5 pr-2 mt-5 pl-6 flex 2 text-white font-semibold text-[18px] bg-blue-primary rounded-xl">
                  <img
                    src="/assets/images/vecteurs/download.svg"
                    alt="download"
                    className="w-6"
                  />
                  <p className="ml-4">
                    {t("teleconsultation.section2.telecharger")}
                  </p>
                </div>
                <div className="py-5 pr-2 my-5 pl-6 flex 2 text-black font-semibold text-[18px] bg-primary-green rounded-xl">
                  <img
                    src="/assets/images/vecteurs/login-svgrepo-com.svg"
                    alt="download"
                    className="w-6"
                  />
                  <p className="ml-4">
                    {t("teleconsultation.section2.inscrivez")}
                  </p>
                </div>
                <div className="py-5 pr-2 my-5 pl-6 flex 2 text-white font-semibold text-[18px] bg-blue-primary rounded-xl">
                  <img
                    src="/assets/images/vecteurs/doctor-svgrepo-com.svg"
                    alt="download"
                    className="w-6"
                  />
                  <p className="ml-4">{t("teleconsultation.section2.plani")}</p>
                </div>
                <div className="py-5 pr-2 my-5 pl-6 flex 2 text-black font-semibold text-[18px] bg-primary-green rounded-xl">
                  <img
                    src="/assets/images/vecteurs/time-success-svgrepo-black.svg"
                    alt="download"
                    className="w-6"
                  />
                  <p className="ml-4">
                    {t("teleconsultation.section2.choisissez")}
                  </p>
                </div>
                <div className="py-5 pr-2 my-5 pl-6 flex 2 text-white font-semibold text-[18px] bg-blue-primary rounded-xl">
                  <img
                    src="/assets/images/vecteurs/video-svgrepo-com.svg"
                    alt="download"
                    className="w-6"
                  />
                  <p className="ml-4">
                    {t("teleconsultation.section2.discutez")}
                  </p>
                </div>
                <div className="py-5 pr-2 my-5 pl-6 flex 2 text-black font-semibold text-[18px] bg-primary-green rounded-xl">
                  <img
                    src="/assets/images/vecteurs/list-square-svgrepo-black.svg"
                    alt="download"
                    className="w-6"
                  />
                  <p className="ml-4">
                    {t("teleconsultation.section2.recevez")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </motion.section>

      {/**  SECTION THREE */}
      <motion.section
        id="section3"
        className="w-full my-9 xl:my-14 py-2 "
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        <p className="text-[#134888] font-bold max-sm:px-5 leading-10 max-md:px-12 text-center px-2 pb-4 text-[37px]">
          {t("teleconsultation.Cards.LesAvantages")}
        </p>
        <motion.div
          id="container"
          initial="hidden"
          animate="visible"
          variants={zoomRotate}
          className="sm:grid sm:grid-cols-2 lg:grid-cols-3 lg:gap-0 max-w-[1550px] mx-auto px-5 lg:px-16"
        >
          {items.map((items, index) => (
            <div
              key={index}
              className="h-full sm:px-1 py-3 md:p-6  lg:py-4 lg:px-2 xl:p-6"
            >
              <div
                className={`h-full ${items.bgColor}  w-[97%]  md:w-[100%]  rounded-2xl shadow-md shadow-gray-400 flex flex-col px-[10px] lg:px-[4px] mx-auto justify-center `}
                style={{ transform: "translate3d(0, 0, 0)" }}
              >
                <div className="max-[370px]:h-[215px] h-[200px] sm:h-[215px] md:h-[200px] lg:h-[210px] pt-2 sm:pt-3 md:pt-6  sm:px-2">
                  <div className=" flex items-center">
                    <div className="bg-[#134888] w-[50px] h-[50px] rounded-xl mt-3 sm:mt-0 md:mt-0 border-none flex justify-center items-center">
                      <img
                        src={items.icon}
                        alt={items.title}
                        className="w-[30px] h-[30px] object-contain"
                      />
                    </div>

                    <p className="text-[#134888] text-[18px] font-bold pl-3  ">
                      {items.title}
                    </p>
                  </div>
                  <p className="  text-[16px] font-medium px-4 ml-12 ">
                    {items.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </motion.div>
      </motion.section>
    </main>
  );
};

export default Teleconsultation;
